
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator";
import StepDatosPersonales from "@/components/Dashboard/StepForm/StepDatosPersonales.vue";
import StepDireccion from "@/components/Dashboard/StepForm/StepDireccion.vue";
import StepDocumentos from "@/components/Dashboard/StepForm/StepDocumentos.vue";

interface Form {
  rut: string | null;
}
@Component({
  components: {
    StepDatosPersonales,
    StepDireccion,
    StepDocumentos
  }
})
export default class SolicitudStep extends Mixins(FormValidator) {
  protected formData: Form = {
    rut: ""
  };
  private formattedRut: string | null = "";
  private loading = false;
  private data: any = null;
  private vFloat = false;
  private rut: string | null = "";
  private step = 1;
  private selectTipoVecino = 0;
  private isFloat: any = null;
  private directoForm = false;

  private disableFlotante = false;
  private disableVecino = false;
  private stepForm: Boolean = true;

  private stepDatos = 2;
  private stepDireccion = 3;
  private stepDocumentos = 4;

  private winSize: boolean = false;
  private window = {
    width: 0,
    height: 0
  };

  @Watch("formattedRut")
  private formatRut(newValue: string) {
    newValue = newValue.replace(/\./g, "");
    this.formData.rut = newValue;
    this.rut = this.formData.rut;
    newValue = newValue.replace(/-/g, "");
    if (newValue.length > 5) {
      const rut = newValue
        .substring(0, newValue.length - 1)
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
      const dv = newValue.substring(newValue.length - 1);
      this.formattedRut = `${rut}-${dv}`;
    } else {
      this.formattedRut = newValue
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
        .toUpperCase();
    }
  }
  @Watch("stepForm")
  private changeStep(newValue: any) {
    if (newValue == false) {
      this.stepDatos = 3;
      this.stepDireccion = 4;
      this.stepDocumentos = 5;
    }
  }

  @Watch("$store.state.cDisabled")
  private watchcDisabled(newValue: any) {
    if (newValue && !this.$store.state.cDisabledF) {
      this.disableFlotante = false;
      this.disableVecino = true;
    } else if (newValue && this.$store.state.cDisabledF) {
      this.disableFlotante = true;
      this.disableVecino = false;
    } else {
      this.disableFlotante = false;
      this.disableVecino = false;
    }
  }

  @Watch("$store.state.cDisabledF")
  private watchcDisabledF(newValue: any) {
    if (this.$store.state.cDisabled && !newValue) {
      this.disableFlotante = false;
      this.disableVecino = true;
    } else if (this.$store.state.cDisabled && newValue) {
      this.disableFlotante = true;
      this.disableVecino = false;
    } else {
      this.disableFlotante = false;
      this.disableVecino = false;
    }
  }

  private created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }
  private destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }

  private handleResize() {
    if (window.innerWidth <= 759) {
      this.winSize = true;
    } else {
      this.winSize = false;
    }
    this.window.width = window.innerWidth;
    this.window.height = window.innerHeight;
  }

  private mounted() {
    if (this.$store.state.cDisabled && !this.$store.state.cDisabledF) {
      this.disableFlotante = false;
      this.disableVecino = true;
    } else if (this.$store.state.cDisabled && this.$store.state.cDisabledF) {
      this.disableFlotante = true;
      this.disableVecino = false;
    } else {
      this.disableFlotante = false;
      this.disableVecino = false;
    }
  }

  private validate() {
    if (!this.formData.rut || !this.validateRut(this.formData.rut)) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.validate").toString(),
        text: this.$t("notifications.error.NO_RUT").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.loading = true;
    this.$axios
      .get("valid/rut?rut=" + this.formData.rut.toUpperCase())
      .then(res => {
        this.data = res.data;
        let dataRut = {
          mensaje: this.data.mensaje,
          titular: this.data.titular
        };
        this.$store.dispatch("SUBMIT_REQUEST_STEP_ONE", dataRut);
        if (this.data.mensaje === "nuevo") {
          if (this.data.titular === "si") {
            this.step = 2;
            this.selectTipoVecino = 1;
            this.isFloat = false;
            this.directoForm = true;
            if (this.data.direccion.calle != "") {
              this.$store.dispatch(
                "SUBMIT_REQUEST_STEP_THREE",
                this.data.direccion
              );
            }
          } else {
            this.step = 2;
            this.selectTipoVecino = 0;
            this.isFloat = false;
            this.directoForm = false;
            this.stepForm = false;
          }
        } else {
          if (this.data.tipoVecino === 1) {
            this.step = 2;
            this.selectTipoVecino = this.data.tipoVecino;
            this.isFloat = false;
            this.directoForm = true;
            if (this.data.direccion.calle != "") {
              this.$store.dispatch(
                "SUBMIT_REQUEST_STEP_THREE",
                this.data.direccion
              );
            }
          } else {
            this.step = 2;
            this.selectTipoVecino = this.data.tipoVecino;
            this.isFloat = true;
            this.directoForm = true;
          }
        }
        this.$q.loading.hide();
        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        this.$q.loading.hide();
        const data = err.response.data;
        let status = "";
        if (data.data === "bloqueado") {
          status = this.$t("status.blocked").toString();
        } else if (data.data === "pagado") {
          status = this.$t("status.payed").toString();
        } else if (data.data === "entregada") {
          status = this.$t("status.physic_card").toString();
        } else if (data.data === "en revision") {
          status = this.$t("status.review").toString();
        } else if (data.data === "por pagar") {
          status = this.$t("status.unpaid").toString();
        } else if (data.data === "corrección") {
          status = this.$t("status.correction").toString();
        } else if (data.data === "anulado") {
          status = this.$t("status.annulled").toString();
        } else if (data.data === "vencido") {
          status = this.$t("status.expired").toString();
        } else if (data.data === "para entrega") {
          status = this.$t("status.delivering").toString();
        } else if (data.data === "para renovar") {
          status = this.$t("status.renew").toString();
        } else if (data.data === "vigente") {
          status = this.$t("status.valid").toString();
        } else if (data.data === "no vigente") {
          status = this.$t("status.invalid").toString();
        } else if (data.data === "tarjeta anulada") {
          status = this.$t("status.c_annuled").toString();
        } else if (data.data === "tarjeta bloqueada") {
          status = this.$t("status.c_blocked").toString();
        }
        if (data.data === "bloqueado") {
          this.$swal({
            icon: "error",
            title: this.$t("notifications.titles.validate").toString(),
            text: this.$t(`notifications.error.RUT_BLOCKED`, {
              rut: this.formattedRut,
              status
            }).toString(),
            confirmButtonText: this.$t("buttons.accept").toString()
          });
        } else if (data.data === "creado") {
          this.$swal({
            icon: "error",
            title: this.$t("notifications.titles.validate").toString(),
            text: this.$t(`notifications.error.NEIGHBOR_EXIST`, {
              rut: this.formattedRut,
              status
            }).toString(),
            confirmButtonText: this.$t("buttons.accept").toString()
          });
        } else if (data.data === "anulado") {
          this.$swal({
            icon: "error",
            title: this.$t("notifications.titles.validate").toString(),
            text: this.$t(`notifications.error.CANCELED_REQUEST`, {
              rut: this.formattedRut,
              status
            }).toString(),
            confirmButtonText: this.$t("buttons.accept").toString()
          });
        } else if (
          data.message == "TOKEN_ERROR" ||
          err.response.data.message == "TOKEN_ERROR"
        ) {
          this.$swal({
            icon: "warning",
            title: this.$t("notifications.titles.atention").toString(),
            text: this.$t("notifications.error.TOKEN_ERROR").toString(),
            confirmButtonText: this.$t("buttons.accept").toString()
          });
          this.$router.push({ name: "login" }).catch(err => {});
        } else {
          this.$swal({
            icon: "error",
            title: this.$t("notifications.titles.validate").toString(),
            text: this.$t(`notifications.error.${data.message}`, {
              rut: this.formattedRut,
              status
            }).toString(),
            confirmButtonText: this.$t("buttons.accept").toString()
          });
        }
      });
  }

  private selectTipo(value) {
    this.loading = true;
    if (value === 1) {
      this.selectTipoVecino = value;
      this.loading = false;
      this.isFloat = false;
    } else {
      this.selectTipoVecino = value;
      this.loading = false;
      this.isFloat = true;
    }
    this.step = 3;
  }

  private stepOne(e: any) {
    this.step = e.step;
  }
  private stepNext(e: any) {
    this.step = e.step;
  }

  private volver() {
    this.$router.go(-1);
  }
}
